import { Box, Grid, Typography } from '@mui/material'
import React from 'react'
import { CardBrand } from '../../../../types/paymentMethod'
import { CardBrandIcon } from '../../../../assets/icons'
import { EmvChipIcon } from '../../../../assets/icons/card/EmvChipIcon'

const CARD_BRAND_BG_MAP = new Map<string, string>([
  [CardBrand.AMEX, 'linear-gradient(84.84deg, #448C64 7.92%, #5FC592 81.62%)'],
  [
    CardBrand.DINERS_CLUB,
    'linear-gradient(135deg, #47A2D6 0%, #4EA7DA 0.01%, #ABDAF5 100%)',
  ],
  [CardBrand.DISCOVER, 'linear-gradient(135deg, #E18338 0%, #EAB07F 99.48%)'],
  [CardBrand.JCB, 'linear-gradient(108.2deg, #703338 14.92%, #977074 79.94%)'],
  [CardBrand.MASTERCARD, 'linear-gradient(135deg, #000000 0%, #555555 100%)'],
  [CardBrand.UNION_PAY, 'linear-gradient(135deg, #88898B 2.52%, #C8C8C8 100%)'],
  [CardBrand.VISA, 'linear-gradient(142.06deg, #1A1E71 6.08%, #1E60AA 96.71%)'],
])

export interface CreditCardProps {
  brand: string
  lastFour: string
  expiration: string
}

const CreditCard = (props: CreditCardProps) => {
  const background = CARD_BRAND_BG_MAP.get(props.brand)
  return (
    <Grid
      container
      sx={theme => ({
        padding: theme.spacing(1.5, 1.5, 1.25, 1.5),
        gap: theme.spacing(1),
        background,
        borderRadius: '8px',
      })}
    >
      <Grid
        item
        container
        justifyContent={'space-between'}
        sx={theme => ({
          height: theme.spacing(2.375),
          fontSize: '1rem',
        })}
      >
        <Box sx={{ position: 'relative', top: 0 }}>
          <CardBrandIcon
            brand={props.brand}
            height='auto'
            width='auto'
            isLightIcon
          />
        </Box>
        <Box
          sx={theme => ({
            position: 'relative',
            top: theme.spacing(-0.375),
            right: theme.spacing(0.375),
          })}
        >
          <EmvChipIcon />
        </Box>
      </Grid>
      <Grid item container justifyContent={'space-between'}>
        <Typography
          sx={{
            color: '#FFFFFF',
            lineHeight: 1,
            fontWeight: 600,
          }}
        >
          *{props.lastFour}
        </Typography>
        <Typography
          sx={{
            color: '#FFFFFFCC',
            lineHeight: 1,
            fontWeight: 400,
          }}
        >
          {props.expiration}
        </Typography>
      </Grid>
    </Grid>
  )
}

export default CreditCard
